import { useVATStore } from '../../stores/VATStore';

export const VatActions = () => {
    const { currentStep, loading, nextStep, previousStep } = useVATStore();

    return <div className="button-group">
        {loading ? <button className="loading-button loading" disabled>
            <span className="spinner"></span>
            Saving ...
        </button> : <>
            {['gcl_information'].includes(currentStep) ? <button className="nav-button previous-button" onClick={previousStep}>
                Previous
            </button> : ''}

            {['vat_information', 'gcl_information'].includes(currentStep) ? <button className="nav-button next-button" onClick={nextStep}>
                Next
            </button> : ''}

        </>}
    </div>;
}